import MentoringTeamCardMentor from './MentoringTeamCardMentor.vue';

export * from './types';
export default MentoringTeamCardMentor;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/teamcard/components/mentor/index.ts